import React, { Component, useState, Fragment } from "react";
import SawasdeeContext from "./SawasdeeContext";
import { DateUtils } from "../../utils";
import { SpaceBox } from "../../components/Space";
import DatePickerComponent from "../../components/Datepicker";
import { CONTACT_TIME, CONTACT_REASON } from "../../data/personal";
import SelectComponent from "../../components/Select";
import InputMask from "react-input-mask";
import CloseTab from "../../images/close.svg";
import ContactFormComponent from "../../components/ContactForm";
import moment from "moment";
const imgScale = {
  width: "24px",
  height: "24px"
};
const Icon = props => (
  <img className={props.className} src={props.src} {...imgScale} />
);

class InternationalStep7 extends Component {
  callBackAction;
  constructor(props) {
    super(props);
  }

  render() {
    const { step7 } = this.context;
    const { onNavigate } = step7;
    const {
      cName,
      cLastName,
      cMobile,
      cEmail,
      cReason,
      cDetail,
      cDate,
      cTime,
      onChangeModel
    } = step7;
    return (
      <div className="form-wrapper">
        <div className="form-group">
          <div className="header" onClick={() => onNavigate(1)}>
            <Icon className="float-right" src={CloseTab} />
          </div>
          <label className="text-blue font-bold mb-3 mt-3 ml-0">
            สนใจให้เจ้าหน้าที่ติดต่อกลับ
          </label>
          <div className="form-group">
            <ContactFormComponent
              productName={'MTI06119'}
              time={CONTACT_TIME}
              reason={CONTACT_REASON}
              cName={cName}
              cLastName={cLastName}
              cMobile={cMobile}
              cEmail={cEmail}
              cReason={cReason}
              cDetail={cDetail}
              cDate={cDate}
              cTime={cTime}
              onChange={onChangeModel}
              productNAme={""}
              onSubmit={() => (window.location.href = "/?callback=1")}
            />
          </div>
        </div>
      </div>
    );
  }
}

InternationalStep7.contextType = SawasdeeContext;
export default InternationalStep7;
